const ASSET_ORIGIN = (process.env.VUE_APP_ASSET_ORIGIN || 'http://www.hwm.red').replace(/\/+$/, '')

const pickAssetPath = (input) => {
    if (!input) return ''

    if (typeof input === 'string' || typeof input === 'number') {
        return String(input).trim()
    }

    if (Array.isArray(input)) {
        return pickAssetPath(input[0])
    }

    if (typeof input === 'object') {
        const keys = ['file_path', 'filePath', 'url', 'path', 'src', 'image_url', 'image', 'cover', 'card_image']
        for (const key of keys) {
            const value = pickAssetPath(input[key])
            if (value) return value
        }
    }

    return ''
}

const resolveAssetUrl = (input) => {
    const raw = pickAssetPath(input)
    if (!raw) return ''

    if (/^(data|blob):/i.test(raw)) return raw
    if (/^\/\//.test(raw)) {
        return `${window.location.protocol}${raw}`
    }

    if (/^https?:\/\//i.test(raw)) {
        try {
            const parsed = new URL(raw)
            const isLocalHost = ['localhost', '127.0.0.1'].includes(parsed.hostname)
            if (isLocalHost) {
                return raw
            }
        } catch (e) {
            return raw.replace(/^http:\/\/localhost:\d+/i, ASSET_ORIGIN)
        }
        return raw
    }

    const cleaned = raw.replace(/^\/+/, '')
    const path = cleaned.startsWith('uploads/') ? `/${cleaned}` : `/uploads/${cleaned}`
    return `${ASSET_ORIGIN}${path}`
}

export default {
    data(){
        return {
            // 自定义订单状态数据
            order_status_data:[
                {status:10,text:'In Progress'},
                {status:20,text:'Cancelled'},
                {status:30,text:'Completed'},
                {status:40,text:'Not Arrived'},
            ]
        }
    },
    computed:{
        getUrl(){
            return url=>{
                return resolveAssetUrl(url)
            }
        },
    },
    methods: {
        // 将本地挂钟时间字符串按指定时区转为 Unix 秒时间戳
        localTimeToTimestamp(dateStr, timezone) {
            const match = String(dateStr).replace(/\//g, '-').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/)
            if (!match) return null
            const [, year, month, day, hour, minute, second = '00'] = match
            const dummyUtc = new Date(Date.UTC(+year, +month - 1, +day, +hour, +minute, +second))
            const parts = new Intl.DateTimeFormat('en-CA', {
                timeZone: timezone,
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                hour12: false
            }).formatToParts(dummyUtc)
            const get = (type) => ((parts.find(p => p.type === type)) || {}).value || '00'
            const tzH = get('hour') === '24' ? '00' : get('hour')
            const tzUtc = new Date(Date.UTC(+get('year'), +get('month') - 1, +get('day'), +tzH, +get('minute'), +get('second')))
            return Math.floor((2 * dummyUtc.getTime() - tzUtc.getTime()) / 1000)
        },
        // 获取对应的订单状态
        getMixinOrderStatus(status){
            let text = ''
            const index = this.order_status_data.findIndex(item=>{
                return item.status == status
            })
            if( index != -1 ){
                text = this.order_status_data[index].text
            }
            return text
        },
        // 转换时间戳为指定格式的日期，timezone 可选（商家时区，如 'America/New_York'）
        formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss', timezone = '') {
            // 处理秒级时间戳（10位）转换为毫秒级（13位）
            const isNumericTimestamp = typeof timestamp === 'number' || /^\d{10,13}$/.test(String(timestamp))
            if (isNumericTimestamp && String(timestamp).length === 10) {
                timestamp = Number(timestamp) * 1000
            }
            const date = new Date(isNumericTimestamp ? Number(timestamp) : timestamp);
            if (isNaN(date.getTime())) {
                return 'Invalid timestamp'
            }
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            // 若传入商家时区且输入是 Unix 时间戳，用 Intl 在目标时区提取各字段
            if (timezone && isNumericTimestamp) {
                try {
                    const parts = new Intl.DateTimeFormat('en-US', {
                        timeZone: timezone,
                        year: 'numeric', month: 'numeric', day: 'numeric',
                        hour: 'numeric', minute: '2-digit', second: '2-digit',
                        hour12: false, weekday: 'long'
                    }).formatToParts(date)
                    const get = (type) => ((parts.find(p => p.type === type)) || {}).value || ''
                    const tzYear = get('year')
                    const tzMonthNum = Number(get('month'))
                    const tzMonth = String(tzMonthNum).padStart(2, '0')
                    const tzDay = get('day').padStart(2, '0')
                    const rawH = get('hour')
                    const tzH24 = rawH === '24' ? 0 : Number(rawH)
                    const tzHours24 = String(tzH24).padStart(2, '0')
                    const tzHours12 = String(tzH24 % 12 || 12).padStart(2, '0')
                    const tzMinutes = get('minute')
                    const tzSeconds = get('second')
                    const tzAmpm = tzH24 >= 12 ? 'PM' : 'AM'
                    const tzMonthName = monthNames[tzMonthNum - 1] || ''
                    const tzDayName = get('weekday')
                    return format
                        .replace('YYYY', tzYear)
                        .replace('MMMM', tzMonthName)
                        .replace('MM', tzMonth)
                        .replace('dddd', tzDayName)
                        .replace('DD', tzDay)
                        .replace('hh', tzHours12)
                        .replace('HH', tzHours24)
                        .replace('mm', tzMinutes)
                        .replace('ss', tzSeconds)
                        .replace('A', tzAmpm)
                } catch(_) {}
            }
            // 兜底：浏览器本地时区
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = date.getHours();
            const hours24 = String(hours).padStart(2, '0');
            const hours12 = String(hours % 12 || 12).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const monthName = monthNames[date.getMonth()];
            const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayName = dayNames[date.getDay()];
            return format.replace('YYYY', year)
                        .replace('MMMM', monthName)
                        .replace('MM', month)
                        .replace('dddd', dayName)
                        .replace('DD', day)
                        .replace('hh', hours12)
                        .replace('HH', hours24)
                        .replace('mm', minutes)
                        .replace('ss', seconds)
                        .replace('A', ampm);
        },
    }
}
